<template>
  <v-overlay opacity="0.6" :value="$store.state.alert.visible">
    <v-alert prominent :type="$store.state.alert.type == 'confirm' ? 'info' : $store.state.alert.type" max-width="400px">
      <v-row align="center">
        <v-col class="grow" v-html="$store.state.alert.message"></v-col>
        <v-col class="shrink" v-if="$store.state.alert.type != 'confirm'">
          <v-btn @click="hide" color="primary">Ok</v-btn>
        </v-col>
      </v-row>
      <v-row align="center" v-if="$store.state.alert.detailMessage">
        <v-col v-html="$store.state.alert.detailMessage">
        </v-col>
      </v-row>
      <v-row align="center" v-if="$store.state.alert.type == 'confirm'">
        <v-col>
          <v-btn @click="confirm" color="primary">confirm</v-btn>
        </v-col>
        <v-col>
          <v-btn @click="hide" color="secondary">cancel</v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </v-overlay>
</template>

<script>
export default {
  name: "Alerter",
  methods: {
    hide() {
      const hh = this.$store.state.alert.hideHandler
      if (hh) {
        this.$nextTick(() => hh())
      }
      this.$store.commit('alert', [false])
    },
    confirm() {
      const ch = this.$store.state.alert.confirmHandler
      if (ch) {
        this.$nextTick(() => ch())
      }
      this.$store.commit('alert', [false])
    }
  }
}
</script>

<style scoped>
.v-card {
  max-width: 90%;
  max-height: 50%;
  margin: auto;
  justify-content: center;
  margin-top: 25%;
  padding: 2% 2% 2% 2%;
}
.v-card h1 {
  margin: auto;
  justify-content: center;
  display: flex;
}
.v-card .v-btn {
  margin: auto;
  justify-content: center;
  display: flex;
  margin-bottom: 20px;
}
</style>